import { cn } from '@/lib/utils';

export default function Toolbar({ children }) {
  return (
    <div
      className={cn(
        // Animates left in step with the sidebar (--sidebar-width flips
        // instantly; the transition is what smooths it). Must match the
        // duration/easing of the aside and main in RootLayout.
        'fixed left-0 md:left-[var(--sidebar-width)] right-0 top-14 px-8 py-3 z-10 min-h-[65px]',
        'transition-[left] duration-200 ease-in-out',
        'border-b shadow-sm',
        'bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80'
      )}
    >
      <div className="flex items-center justify-between">{children}</div>
    </div>
  );
}
